import {create} from "zustand/react";
import {ApiCall} from "../util/ApiCall";
import {ICrossCurrency} from "../interfaces/ICrossCurrency";
import {useUnitsState} from "./UnitsState";

export interface CurrencyState {
  loading: boolean;
  drawerOpen: boolean;
  currentCurrency: ICrossCurrency | undefined;
  rates: ICrossCurrency[];
  load: () => void;
  setByCode: (code: string) => void;
  setCurrentCurrency: (currency: ICrossCurrency) => void;
  toggleDrawer: () => void;
  closeDrawer: () => void;
  openDrawer: () => void;
}

export const useCurrencyState = create<CurrencyState>(
  (set) => ({
    loading: true,
    drawerOpen: false,
    currentCurrency: undefined,
    rates: [],
    async load() {
      set(() => ({loading: true}))
      const data = await ApiCall
        .get<ICrossCurrency[]>("/storefront/rates")
      set(() => ({rates: data, loading: false}))
    },
    setByCode: (code: string) => set(state => {
      const companyCurrency = state.rates.find(r => r.currency_code == code)
      return {currentCurrency: companyCurrency}
    }),
    setCurrentCurrency: (currency: ICrossCurrency) => set(() => ({currentCurrency: currency})),
    toggleDrawer: () => set(state => ({drawerOpen: !state.drawerOpen})),
    openDrawer: () => set(() => ({drawerOpen: true})),
    closeDrawer: () => set(() => ({drawerOpen: false})),
  })
)

export function useCurrencyConvert(): (value: number) => number {
  const unitsState = useUnitsState()
  const from = unitsState.company.currency
  const state = useCurrencyState()
  const to = state.currentCurrency?.currency_code ?? 'USD'
  return (value: number)=> {
    const _from = state.rates.find(r => r.currency_code === from)
    const _to = state.rates.find(r => r.currency_code === to)
    if(_from && _to) {
      const usdvalue = (from !== 'USD') ? Math.round(value / _from.exchange_rate) : value
      const tovalue = Math.round(usdvalue * _to.exchange_rate)
      return (to === 'USD' ? usdvalue : tovalue)
    }
    return 0
  }
}